/** 产品委外订单 — 门户展示状态（由 ERP 三字段推导，不新增后端字段） */

export const PORTAL_ORDER_STATUS = {
  PENDING_RECEIVE: 'pending_receive',
  PROCESSING: 'processing',
  PENDING_SHIP: 'pending_ship',
  COMPLETED: 'completed'
}

export const PORTAL_ORDER_STATUS_OPTIONS = [
  {
    label: '待收料',
    value: PORTAL_ORDER_STATUS.PENDING_RECEIVE,
    color: 'white',
    backGroundColor: 'rgb(230, 162, 60)'
  },
  {
    label: '加工中',
    value: PORTAL_ORDER_STATUS.PROCESSING,
    color: 'white',
    backGroundColor: 'rgb(64, 158, 255)'
  },
  {
    label: '待发货',
    value: PORTAL_ORDER_STATUS.PENDING_SHIP,
    color: 'white',
    backGroundColor: 'rgb(103, 194, 58)'
  },
  {
    label: '已完成',
    value: PORTAL_ORDER_STATUS.COMPLETED,
    color: 'white',
    backGroundColor: 'rgb(106, 168, 79)'
  }
]

/** 与 ERP calculateReceiptStatus 一致；协同 vagueList 未返回 statusReceipt 时按数量推导 */
export function resolveStatusReceipt(row) {
  if (row.statusReceipt != null && row.statusReceipt !== '') {
    return Number(row.statusReceipt)
  }
  const shipped = Number(row.valueInwarehouseQuantity) || 0
  const orderQty = Number(row.baseOutsourcingQuantity) || 0
  if (shipped <= 0) return 0
  if (shipped < orderQty) return 1
  if (shipped === orderQty) return 2
  return 3
}

/**
 * statusRequisition 发料：0未发料 1部分发料 2全发料 3超发料
 * statusReceipt   收货：0未收货 1部分收货 2完全收货 3超量收货
 * statusDoc       单据：0进行中 1已完成 2已终止
 *
 * 部分发料后允许部分出货：只有「未发料」算待收料；
 * 部分/全/超发料后按成品收货进度进入加工中或待发货。
 */
export function resolvePortalOrderStatus(row) {
  const statusDoc = Number(row.statusDoc ?? 0)
  const statusRequisition = Number(row.statusRequisition ?? 0)
  const statusReceipt = resolveStatusReceipt(row)

  if (statusDoc === 1 || statusDoc === 2 || statusReceipt >= 2) {
    return PORTAL_ORDER_STATUS.COMPLETED
  }
  if (statusRequisition === 0) {
    return PORTAL_ORDER_STATUS.PENDING_RECEIVE
  }
  if (statusReceipt === 1) {
    return PORTAL_ORDER_STATUS.PENDING_SHIP
  }
  return PORTAL_ORDER_STATUS.PROCESSING
}

/** 未完成订单都可能继续收后续发料（部分发料与部分出货可并行） */
export function canReceivePortalOrder(row) {
  return resolvePortalOrderStatus(row) !== PORTAL_ORDER_STATUS.COMPLETED
}

/** 本厂已开始发料即可出货；未发料、已完成不可出货 */
export function canShipPortalOrder(row) {
  const status = resolvePortalOrderStatus(row)
  return (
    status !== PORTAL_ORDER_STATUS.COMPLETED &&
    status !== PORTAL_ORDER_STATUS.PENDING_RECEIVE
  )
}

export function getPortalOrderStatusLabel(status) {
  const item = PORTAL_ORDER_STATUS_OPTIONS.find((o) => o.value === status)
  return item ? item.label : status
}

/**
 * 门户订单状态 → outsourcingDocFilter 三字段 List 查询参数（与 resolvePortalOrderStatus 推导规则对应）
 */
export function buildPortalStatusFilter(portalOrderStatus) {
  if (!portalOrderStatus) {
    return {}
  }
  switch (portalOrderStatus) {
    case PORTAL_ORDER_STATUS.PENDING_RECEIVE:
      return {
        statusDocList: [0],
        statusRequisitionList: [0],
        statusReceiptList: [0]
      }
    case PORTAL_ORDER_STATUS.PROCESSING:
      return {
        statusDocList: [0],
        statusRequisitionList: [1, 2, 3],
        statusReceiptList: [0]
      }
    case PORTAL_ORDER_STATUS.PENDING_SHIP:
      return {
        statusDocList: [0],
        statusRequisitionList: [1, 2, 3],
        statusReceiptList: [1]
      }
    case PORTAL_ORDER_STATUS.COMPLETED:
      // 协同出货不回写 ERP statusDoc；已出齐即可进「已完成」
      return {
        statusReceiptList: [2, 3]
      }
    default:
      return {}
  }
}
